export var LoaderEvent;
(function (LoaderEvent) {
    LoaderEvent["SHOW_SPLASH"] = "SplashLoaderEvent.Show";
    LoaderEvent["HIDE_SPLASH"] = "SplashLoaderEvent.Hide";
})(LoaderEvent || (LoaderEvent = {}));
